import { Backdrop, Button, Card, CardContent, CircularProgress, Container, Divider, Grid, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Dialog, DialogContent, TablePagination, Typography, Paper, Box, Autocomplete, Stack } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Alert from 'src/components/Alert';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import trLocale from 'date-fns/locale/tr';
import HearingIcon from '@mui/icons-material/Hearing';
import WaveformPlayer from 'src/components/WaveformPlayer';
import * as XLSX from 'xlsx';

const localeMap = {
    tr: trLocale
};

// Excel hücre sınırı 32767 karakter; aşan metin yanına açılan Kolon1, Kolon2... sütunlarına taşınır
const EXCEL_HUCRE_SINIRI = 32767;

const parcaSayisi = (deger) =>
    typeof deger === 'string' ? Math.max(1, Math.ceil(deger.length / EXCEL_HUCRE_SINIRI)) : 1;

const excelTasmaBol = (rows) => {
    const kolonlar = rows.length ? Object.keys(rows[0]) : [];
    const kolonParca = {};
    kolonlar.forEach((kolon) => {
        kolonParca[kolon] = rows.reduce((max, row) => Math.max(max, parcaSayisi(row[kolon])), 1);
    });

    const header = kolonlar.flatMap((kolon) =>
        Array.from({ length: kolonParca[kolon] }, (_, i) => (i === 0 ? kolon : kolon + i))
    );

    const data = rows.map((row) => {
        const yeniRow = {};
        kolonlar.forEach((kolon) => {
            const deger = row[kolon];
            if (kolonParca[kolon] === 1 || typeof deger !== 'string') {
                yeniRow[kolon] = deger;
                return;
            }
            for (let i = 0; i < kolonParca[kolon]; i++) {
                yeniRow[i === 0 ? kolon : kolon + i] = deger.slice(i * EXCEL_HUCRE_SINIRI, (i + 1) * EXCEL_HUCRE_SINIRI);
            }
        });
        return yeniRow;
    });

    return { header, data };
};

// Aynı AI_ID'li kayıtların ilkini tutar; AI_ID = 0 olanlara dokunmaz
const tekrarlariTemizle = (rows) => {
    const gorulen = new Set();
    return rows.filter((item) => {
        if (item.AI_ID === 0) return true;
        if (gorulen.has(item.AI_ID)) return false;
        gorulen.add(item.AI_ID);
        return true;
    });
};

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    table: {
        minWidth: 650,
    },
    button: (theme) => ({
        margin: theme.spacing(1),
    }),
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }),
    title: (theme) => ({
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    }),
    media: (theme) => ({
        height: 210,
        padding: theme.spacing(6, 2)
    }),
    customCardContent: {
        '&.MuiCardContent-root:last-child': {
            paddingBottom: '0.65rem'
        }
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '10px',
        borderRadius: 10
    }
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;





function SestekAi() {
    const params = useParams();
    const [search, setSearch] = React.useState('');
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [dataMain, setDataMain] = useState([]);
    const [mainSearchData, setMainSearchData] = useState([]);
    const [dataDetail, setDataDetail] = useState([]);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [DailerOpen, setDailerOpen] = React.useState(false);
    const [DailerData, setDailerData] = React.useState([]);
    const [DailerDataLink, setDailerDataLink] = React.useState('');
    const [audio, setAudio] = React.useState(new Audio(''));
    const [DailerOpenLink, setDailerOpenLink] = React.useState(false);
    const [UyariAciklama, setUyariAciklama] = useState("");
    const [expandedRowId, setExpandedRowId] = useState(null);

    const [projectData, setProjectData] = useState([]);
    const [selectedProject, setSelectedProject] = useState({ "ID": 0, "ACIKLAMA": "All Type" });
    const [projectTypeLoading, setProjectTypeLoading] = useState(false);

    const waveformRef = useRef();
    const searchInputRef = useRef();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [StartDate, setStartDate] = useState(
        new Date()
    );
    const [EndDate, setEndDate] = useState(
        new Date()
    );
    const formattedStartDate = moment(StartDate).format('YYYY-MM-DD')
    const formattedEndDate = moment(EndDate).format('YYYY-MM-DD')
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });


    React.useEffect(() => {
        getAiProjectTypes();
    }, [])

    const getAiProjectTypes = () => {
        setProjectTypeLoading(true);
        const isActiveTestConversation = "1"
        axios.get(`/GetAiProjectTypes/${isActiveTestConversation}`)
            .then((response) => {
                const data = response.data;
                setProjectData(data);
                setProjectTypeLoading(false);
            }).catch((err) => {
                setProjectTypeLoading(false);
            });
    }

    const getMainData = () => {
        setDataMain([]);
        setMainSearchData([]);
        setDataDetail([]);
        setSelectedRowId(null);
        setExpandedRowId(null);
        setPage(0);
        setRowsPerPage(20);
        setLoading(true);

        // Search input'u manuel temizle (onChange tetiklenmeden)
        if (searchInputRef.current) {
            searchInputRef.current.value = '';
            setSearch('');
        }

        var selectedProjectId = selectedProject.ID
        axios.get('GetSestekAiMain/' + formattedStartDate + '/' + formattedEndDate + '/' + selectedProjectId)
            .then((response) => {
                const uniqueData = tekrarlariTemizle(response.data);
                setDataMain(uniqueData);
                setMainSearchData(uniqueData);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }

    const getDetailData = (Id) => {
        setDataDetail([]);
        setLoading(true);
        axios.get('GetSestekAiDetail/' + Id)
            .then((response) => {
                setDataDetail(response.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }


    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };



    const handleSearch = async (event) => {
        const newString = event?.target.value;
        setSearch(newString);

        if (!mainSearchData || mainSearchData.length === 0) {
            return;
        }

        if (newString) {
            const lowercasedNewString = newString.toLowerCase('tr-TR');
            const filteredData = mainSearchData.filter(item => {
                const concatenatedStr = `${item.ConversaitonID}
                ${item.CallerPhoneNumber}
                ${item.CallEndStatus}
                ${item.LiveAgentTransferReason}
                ${item.ContactPhoneNumber}
                ${item.CaseID}
                ${item.ErrorLog}
                ${item.Result}
                ${item.Result_explanation}
                ${item.Ended_Stage}
                ${item.Project}
                ${item.FeedbackCategory}
                ${item.Feedback}
                ${item.SMSInfo}
                ${item.Failure_Point}`;

                // ${item.} ${item.}
                // ${item.} ${item.}
                // ${item.} ${item.}

                const lowercasedConcatenatedStr = concatenatedStr.toLowerCase('tr-TR');
                return lowercasedConcatenatedStr.includes(lowercasedNewString);
            });

            const uniqueFilteredData = tekrarlariTemizle(filteredData);
            setDataMain(uniqueFilteredData);
            setPage(0);
        } else {
            setDataMain(mainSearchData);
            setPage(0);
        }
    };



    const GetDailerLink = () => {
        if (!selectedRowId) {
            setresponseMessage('Lütfen bir görüşme seçiniz!...');
            setUyariTip("error");
            setUyari(true);
            return;
        }

        var CallId = selectedRowId;
        // var CallId = 70177784;
        setLoading(true);
        setDailerOpen(true);
        axios.get('/GetDailerDataLink/' + CallId).then((response) => {
            const PaperCC = response.data;
            console.log(PaperCC);
            setDailerDataLink(PaperCC);
            setAudio(new Audio(PaperCC));
            setDailerOpenLink(true);
            setLoading(false);
        }).catch(error => {
            setUyariTip("error");
            setUyariAciklama("Yetkiniz bulunmamaktadır!...");
            setUyari(true);
            setLoading(false);
        });
    }

    const handleCloseDailerLink = () => {
        waveformRef.current?.stop();
        setDailerOpenLink(false);
    };



    const toggleExpanded = (id) => {
        setExpandedRowId(prev => prev === id ? null : id);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDownloadExcel = () => {
        let excelData = dataMain.map((row) => ({
            Project: row.Project,
            GorusmeID: row.ConversaitonID,
            Tarih: row.TARIH,
            Sure: row.Duration,
            SonucAi: row.Result,
            SonucAiAçıklama: row.Result_explanation,
            SonAdımAi: row.Ended_Stage,
            HataAdımıAi: row.Failure_Point,
            Durum: row.CallEndStatus,
            Neden: row.LiveAgentTransferReason,
            Marka: row.Brand,
            Ürün: row.Product,
            TalepID: row.CaseID,
            RandevuID: row.AppointmentID,
            HataKaydı: row.ErrorLog,
            GeriBildirimTipi: row.FeedbackCategory,
            GeriBildirimAciklamasi: row.Feedback
        }))

        const { header, data } = excelTasmaBol(excelData);

        const ws = XLSX.utils.json_to_sheet(data, { header });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "SestekAiRapor");
        XLSX.writeFile(wb, "SestekAiRapor.xlsx", { compression: true });
    }

    return (
        <Page sx={styles.root}>
            <Backdrop sx={styles.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container maxWidth={false}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <TextField
                                    inputRef={searchInputRef}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    placeholder="Arama"
                                    value={search}
                                    onChange={handleSearch}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    adapterLocale={localeMap['tr']}
                                >
                                    <DatePicker
                                        label={'Başlangıç Tarihi'}
                                        format={'dd.MM.yyyy'}
                                        value={StartDate}
                                        onChange={date => {
                                            setStartDate(date);
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                color: 'primary',
                                                variant: 'outlined'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    adapterLocale={localeMap['tr']}
                                >
                                    <DatePicker
                                        label={'Bitiş Tarihi'}
                                        format={'dd.MM.yyyy'}
                                        value={EndDate}
                                        onChange={date => {
                                            setEndDate(date);
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                color: 'primary',
                                                variant: 'outlined'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <Autocomplete
                                    options={projectData}
                                    getOptionLabel={(option) => option.ACIKLAMA || ""}
                                    value={selectedProject || ''}
                                    size="small"
                                    onChange={(event, newValue) => {
                                        setSelectedProject(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Project"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {projectTypeLoading ? (
                                                            <CircularProgress color="primary" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                    sx={{
                                        "& .MuiAutocomplete-endAdornment": {
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <Stack direction="row" spacing={1}>
                                    <Button
                                        style={styles.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            getMainData();
                                        }}
                                    >
                                        Sorgula
                                        <SearchIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                    <Button
                                        style={styles.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            handleDownloadExcel();
                                        }}
                                    >
                                        EXCEL İNDİR
                                        <ArrowDownwardIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Stack>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <Stack direction="row" spacing={1}>
                                    <Button
                                        style={styles.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            GetDailerLink();
                                        }}
                                    >
                                        Dİnle
                                        <HearingIcon style={{ marginLeft: '5px' }} />
                                    </Button>

                                </Stack>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 12
                                }}>
                                <Divider />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 8,
                                    lg: 9
                                }}>
                                <TableContainer style={{ maxHeight: 700, minHeight: 700, overflowY: 'auto' }}>
                                    <Table stickyHeader aria-label="sticky table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Project</TableCell>
                                                <TableCell>GörüşmeID</TableCell>
                                                <TableCell>Tarih</TableCell>
                                                <TableCell>Süre</TableCell>
                                                <TableCell>SonucAi</TableCell>
                                                <TableCell>SonucAiAçıklama</TableCell>
                                                <TableCell>SonAdımAi</TableCell>
                                                <TableCell>HataAdımıAi</TableCell>
                                                <TableCell>Durum</TableCell>
                                                <TableCell>Neden</TableCell>
                                                <TableCell>Marka</TableCell>
                                                <TableCell>Ürün</TableCell>
                                                <TableCell>TalepID</TableCell>
                                                <TableCell>RandevuID</TableCell>
                                                <TableCell>ArayanTel</TableCell>
                                                <TableCell>İletişimTel</TableCell>
                                                <TableCell>SmsBilgisi</TableCell>
                                                <TableCell>HataKaydı</TableCell>
                                                <TableCell>GeriBildirimTürü</TableCell>
                                                <TableCell>GeriBildirimAçıklaması</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {dataMain.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                                <TableRow
                                                    key={`${row.AI_ID}-${row.ConversaitonID}-${index}`}
                                                    onClick={() => {
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                    style={{
                                                        backgroundColor: row.ConversaitonID === selectedRowId ? '#e0f7fa' : 'transparent',
                                                        cursor: 'pointer',
                                                    }}
                                                >


                                                    <TableCell
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(row.Project).then(() => {
                                                                console.log("Kopyalandı:", row.Project);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row.Project}</Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(row.ConversaitonID).then(() => {
                                                                console.log("Kopyalandı:", row.ConversaitonID);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row.ConversaitonID}</Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(row.TARIH).then(() => {
                                                                console.log("Kopyalandı:", row.TARIH);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row.TARIH}</Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(row.Duration).then(() => {
                                                                console.log("Kopyalandı:", row.Duration);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row.Duration}</Typography>
                                                    </TableCell>
                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.Result).then(() => {
                                                            console.log("Kopyalandı:", row.Result);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                        style={{ cursor: 'pointer', maxWidth: 250 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.Result}
                                                        </Typography>
                                                    </TableCell>


                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.Result_explanation).then(() => {
                                                            console.log("Kopyalandı:", row.Result_explanation);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                        style={{ cursor: 'pointer', maxWidth: 150 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.Result_explanation}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.Ended_Stage).then(() => {
                                                            console.log("Kopyalandı:", row.Ended_Stage);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                        style={{ cursor: 'pointer', maxWidth: 150 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.Ended_Stage}
                                                        </Typography>
                                                    </TableCell>


                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.Failure_Point).then(() => {
                                                            console.log("Kopyalandı:", row.Failure_Point);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                        style={{ cursor: 'pointer', maxWidth: 150 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.Failure_Point}
                                                        </Typography>
                                                    </TableCell>


                                                    <TableCell
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(row.CallEndStatus).then(() => {
                                                                console.log("Kopyalandı:", row.CallEndStatus);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row.CallEndStatus}</Typography>
                                                    </TableCell>

                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.LiveAgentTransferReason).then(() => {
                                                            console.log("Kopyalandı:", row.LiveAgentTransferReason);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                        style={{ cursor: 'pointer', maxWidth: 150 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.LiveAgentTransferReason}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(row.Brand).then(() => {
                                                                console.log("Kopyalandı:", row.Brand);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row.Brand}</Typography>
                                                    </TableCell>


                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.Product).then(() => {
                                                            console.log("Kopyalandı:", row.Product);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                        style={{ cursor: 'pointer', maxWidth: 150 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.Product}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.CaseID).then(() => {
                                                            console.log("Kopyalandı:", row.CaseID);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                        style={{ cursor: 'pointer', maxWidth: 150 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.CaseID}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.AppointmentID).then(() => {
                                                            console.log("Kopyalandı:", row.AppointmentID);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }}
                                                        style={{ cursor: 'pointer', maxWidth: 150 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.AppointmentID}
                                                        </Typography>
                                                    </TableCell>


                                                    <TableCell
                                                        onClick={() => {
                                                            const text = (row.CallerPhoneNumber ?? "").replace("+90", "");
                                                            navigator.clipboard.writeText(text).then(() => {
                                                                console.log("Kopyalandı:", text);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row.CallerPhoneNumber?.replace('+90', '')}</Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() => {
                                                            const text = (row.ContactPhoneNumber ?? "").replace("+90", "");
                                                            navigator.clipboard.writeText(text).then(() => {
                                                                console.log("Kopyalandı:", text);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row.ContactPhoneNumber?.replace('+90', '')}</Typography>
                                                    </TableCell>

                                                    <TableCell
                                                        onClick={() => {
                                                            const text = (row.SMSInfo ?? "");
                                                            navigator.clipboard.writeText(text).then(() => {
                                                                console.log("Kopyalandı:", text);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row?.SMSInfo}</Typography>
                                                    </TableCell>

                                                    <TableCell onClick={(e) => {
                                                        navigator.clipboard.writeText(row.ErrorLog).then(() => {
                                                            console.log("Kopyalandı:", row.ErrorLog);
                                                        }
                                                        ).catch(err => {
                                                            console.error("Kopyalama hatası:", err);
                                                        });

                                                        e.stopPropagation();
                                                        toggleExpanded(row.AI_ID);
                                                        setSelectedRowId(row.ConversaitonID);
                                                        getDetailData(row.AI_ID);
                                                    }} style={{ cursor: 'pointer', maxWidth: 150 }}>
                                                        <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.AI_ID}>
                                                            {row.ErrorLog}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(row.FeedbackCategory).then(() => {
                                                                console.log("Kopyalandı:", row.FeedbackCategory);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });

                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row?.FeedbackCategory}</Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={(e) => {
                                                            navigator.clipboard.writeText(row.Feedback).then(() => {
                                                                console.log("Kopyalandı:", row.Feedback);
                                                            }
                                                            ).catch(err => {
                                                                console.error("Kopyalama hatası:", err);
                                                            });

                                                            e.stopPropagation();
                                                            toggleExpanded(row.AI_ID);
                                                            setSelectedRowId(row.ConversaitonID);
                                                            getDetailData(row.AI_ID);
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ mt: 0.5 }}>{row?.Feedback}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 20, 40, 80, 100]}
                                    component="div"
                                    count={dataMain.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 4,
                                    lg: 3
                                }}>
                                <Paper
                                    elevation={2}
                                    style={{
                                        maxHeight: 700,
                                        minHeight: 700,
                                        overflowY: 'auto',
                                        padding: 16,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 8,
                                    }}
                                >
                                    {dataDetail?.map((msg) => (
                                        <Box
                                            key={msg.ID}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: msg.Role === 'VirtualAgent' ? 'flex-start' : 'flex-end',
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    maxWidth: '70%',
                                                    p: 1.5,
                                                    borderRadius: 2,
                                                    border: '1px solid',
                                                    color: '#000000',
                                                    borderColor: msg.Role === 'VirtualAgent' ? '#110cfb' : '#89d638',
                                                }}
                                            >
                                                <Typography variant="caption" color="text.secondary">
                                                    {msg.Role === 'VirtualAgent' ? 'Asistan' : 'Müşteri'} - {msg.DATE}
                                                </Typography>
                                                <Typography variant="body2" sx={{ mt: 0.5 }}>
                                                    {msg.ContentType === 'Text' ? (
                                                        msg.Content
                                                    ) : (
                                                        msg.Content
                                                    )}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    ))}
                                </Paper>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <Dialog
                open={DailerOpenLink}
                maxWidth="lg"      // genişliği artırır
                fullWidth
                onClose={handleCloseDailerLink}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <div style={{ maxWidth: 1200, margin: "auto", padding: 20 }}>
                        <WaveformPlayer
                            ref={waveformRef}
                            audioUrl={DailerDataLink}
                            conversationId={selectedRowId}
                            onSaved={(payload) => {
                                const patchRow = (r) =>
                                    r.ConversaitonID === payload.conversationId
                                        ? { ...r, Feedback: payload.feedback, FeedbackCategory: payload.feedbackCategory }
                                        : r;

                                setMainSearchData(prev => prev.map(patchRow));
                                setDataMain(prev => prev.map(patchRow));

                                handleCloseDailerLink();
                            }}

                        />
                    </div>
                </DialogContent>
            </Dialog>

        </Page >
    );
}
export default SestekAi;